import React, { Component } from 'react'
import styled from 'styled-components'
import { justAskArray } from '../../../data/indexContent'
import CtaButtonLg from '../UI/CtaButtonLg'
import Logo from '../Accessories/Logo'
import backgroundImage from '../../assets/newer_background.png'

class HomeHero extends Component {
  constructor(props) {
    super(props)

    this.typewriter = this.typewriter.bind(this)
    this.reverseTypewriter = this.reverseTypewriter.bind(this)
  }

  componentDidMount() {
    if (this.props.description === 'home') {
      this.typewriter(justAskArray, 0, 0)
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timer)
  }

  typewriter(array, n, idx) {
    if (idx === array.length) {
      idx = 0
    }
    const element = document.querySelector('.typewriter')
    const word = element.innerText
    if (n < array[idx].length) {
      element.innerHTML = array[idx].substring(0, n + 1)
      n++
      this.timer = setTimeout(() => {
        this.typewriter(array, n, idx)
      }, 75)
    } else {
      this.timer = setTimeout(
        () => this.reverseTypewriter(array, word.length, idx),
        2000
      )
    }
  }

  reverseTypewriter(array, n, idx) {
    const element = document.querySelector('.typewriter')
    const word = element.innerText
    if (word.length > 0) {
      element.innerHTML = array[idx].substring(0, n - 1)
      n--
      this.timer = setTimeout(() => {
        this.reverseTypewriter(array, n, idx)
      }, 75)
    } else {
      idx++
      this.timer = setTimeout(() => this.typewriter(array, 0, idx), 1000)
    }
  }

  render() {
    return (
      <HomeHeroContainer>
        <div className="HomeHero__content">
          <SiteDescription>
            <div className="web">
              <p className="header">We make enterprise software easier.</p>
              <span>
                Just Ask <span className="typewriter" />
              </span>
            </div>
            <div className="mobile">
              <Logo />
              <h2>AppTree Enterprise Software</h2>
            </div>
          </SiteDescription>
          <ButtonContainer>
            <CtaButtonLg to={'/contact'}>
              See What AppTree Can Do For You →
            </CtaButtonLg>
          </ButtonContainer>
        </div>
      </HomeHeroContainer>
    )
  }
}

export default HomeHero

const HomeHeroContainer = styled.div`
  height: 667px;

  .HomeHero__content {
    position: relative;
    left: 200px;
    top: 50%;
    transform: translateY(-50%);
    display: grid;
    align-content: center;
    align-items: center;
    grid-auto-columns: 700px;
    grid-gap: 20px;
    grid-template-areas:
      'header'
      'description'
      'ctaButton';
  }

  // Background Image
  background-image: url('https://res.cloudinary.com/ericwindmill/image/upload/c_scale,h_700/v1516650801/newer_background_2_clvkz8.png');
  background-repeat: no-repeat;
  background-position: right;

  @media screen and (max-width: 1400px) {
    background-size: 80%;
    height: 550px;
  }

  @media screen and (max-width: 1200px) {
    background-size: 60%;
    height: 500px;
  }

  @media screen and (max-width: 768px) {
    background: white;
    height: inherit;

    .HomeHero__content {
      left: 0;
      top: 0;
      display: block;
      margin: 100px auto 0;
    }
  }
`

const SiteHeader = styled.h1`
  grid-area: header;
  font-size: 4rem;
  max-width: 500px;

  @media screen and (max-width: 768px) {
    margin: auto;
    text-align: center;
  }
`

const SiteDescription = styled.h3`
  grid-area: description;
  .header {
    max-width: 400px;
  }
  p,
  p *,
  span {
    font-size: 4rem;
    line-height: 1.2;
    font-weight: 400;
  }

  .typewriter {
    font-size: 4rem;
    display: inline-block;
  }

  .mobile {
    display: none;
  }

  @media screen and (max-width: 768px) {
    text-align: center;
    margin: auto;
    .web {
      display: none;
    }
    .mobile {
      display: block;
      margin: 20px 0 -40px;
    }
  }
`
const ButtonContainer = styled.div`
  grid-area: ctaButton;
  @media screen and (max-width: 762px) {
    display: none;
  }
`



// WEBPACK FOOTER //
// ./src/components/IndexContent/HomeHero.jsx